import { render, staticRenderFns } from "./PageTestimonials.vue?vue&type=template&id=8e236076&"
import script from "./PageTestimonials.vue?vue&type=script&lang=js&"
export * from "./PageTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./PageTestimonials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports